// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import '@shui/core/sh-access-bar';
import '@shui/core/sh-accordion';
import '@shui/core/sh-button';
import '@shui/core/sh-card';
import '@shui/core/sh-carousel';
import '@shui/core/sh-chart';
import '@shui/core/sh-datepicker';
import '@shui/core/sh-divider';
import '@shui/core/sh-dropdown';
import '@shui/core/sh-empty-state';
import '@shui/core/sh-grid';
import '@shui/core/sh-icon';
import '@shui/core/sh-input-number';
import '@shui/core/sh-list';
import '@shui/core/sh-menu-item';
import '@shui/core/sh-modal';
import '@shui/core/sh-nav-bar';
import '@shui/core/sh-notifications';
import '@shui/core/sh-page';
import '@shui/core/sh-pagination';
import '@shui/core/sh-pane';
import '@shui/core/sh-popover';
import { SHPopover } from '@shui/core/sh-popover';
import '@shui/core/sh-progress';
import '@shui/core/sh-radio-button';
import '@shui/core/sh-search';
import '@shui/core/sh-spinner';
import '@shui/core/sh-table';
import '@shui/core/sh-tabs';
import '@shui/core/sh-tag';
import '@shui/core/sh-text';
import '@shui/core/sh-toggle';
import '@shui/core/sh-tool';
import '@shui/core/sh-tooltip';
import '@shui/core/sh-user-identifier';

// this patches a shui bug where menues are placed at negative top locations
// moving them off the screen at the top
(() => {
  const proto = document.createElement('sh-popover').constructor
    .prototype as typeof SHPopover;
  const wrapped = (proto as any).setOverlayPlacement;
  (proto as any).setOverlayPlacement = function (...args: any[]) {
    wrapped.call(this, ...args);
    if (parseInt(this.style.top) < 0) {
      this.style.top = '68px';
    }
  };
})();
